import { useEffect, useState } from 'react';
import { useNavigate }   from "react-router-dom";
import { useSelector } from "react-redux";

import { toast } from 'react-toastify';
import { uploadImagePresigned } from '../utils/s3Upload';

export const UploadFile = () => {
    const navigate   = useNavigate();
    const StorageId = JSON.parse(localStorage.CurrentUrl);
    const patient = useSelector(state => state.patients.patient);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [file, setFile] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        console.log(StorageId.id.id)
        console.log(patient)
    }, []);
    const handleClose = (id) => {
        navigate(`/patients/${id}/hc`);
    }
    const MAX_FILES     = 10;
    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const MAX_TOTAL     = 100 * 1024 * 1024;

    const handleSelectFile = (e) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        if (files.length > MAX_FILES) {
            toast.error(`Podés seleccionar un máximo de ${MAX_FILES} archivos.`);
            return;
        }
        let totalSize = 0;
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > MAX_FILE_SIZE) {
                toast.error(`El archivo "${files[i].name}" supera los 20 MB.`);
                return;
            }
            totalSize += files[i].size;
        }
        if (totalSize > MAX_TOTAL) {
            toast.error('El total de los archivos supera los 100 MB.');
            return;
        }
        const currentFiles = Array.isArray(file) ? file : Array.from(file);
        const combined = [...currentFiles, ...Array.from(files)];
        const newUrls = Array.from(files).map(f => URL.createObjectURL(f));
        setFile(combined);
        setSelectedFiles(prev => [...prev, ...newUrls]);
    }

    const handleDeleteImage = () => {
        selectedFiles.forEach(url => URL.revokeObjectURL(url));
        setSelectedFiles([]);
        setFile([]);
    };

    const handleRemoveFile = (index) => {
        URL.revokeObjectURL(selectedFiles[index]);
        setFile(prev => prev.filter((_, i) => i !== index));
        setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const uploadFiles = async () => {
        if (!file || file.length === 0) {
            toast.error('Seleccioná al menos un archivo.');
            return;
        }
        const fileArray = Array.from(file);
        let ok = 0;
        let fail = 0;

        setLoading(true);
        for (const f of fileArray) {
            try {
                await uploadImagePresigned(patient.id, f);
                ok++;
            } catch (err) {
                console.error('uploadFiles error:', err);
                fail++;
            }
        }
        setLoading(false);

        if (fail === 0) {
            toast.success(`${ok}/${fileArray.length} ${fileArray.length === 1 ? 'foto subida' : 'fotos subidas'} correctamente`);
        } else {
            toast.success(`${ok}/${fileArray.length} fotos subidas correctamente`);
            toast.error(`${fail} ${fail === 1 ? 'archivo no se pudo subir' : 'archivos no se pudieron subir'}`);
        }
        navigate(`/patients/${patient.id}/hc`);
    }

  return (
    <>
    <div className="flex flex-col h-screen justify-between items-center bg-black">
        <div className="bg-black grid grid-cols-2 items-start py-4">
          <h3 className="pl-[10%] w-[350px] text-lg text-white">
            <span className="">
              Paciente:{' '}
              <span className="font-bold capitalize">
                {patient.surname}, {patient.name}
              </span>
            </span>
          </h3>
          <button onClick={() => handleClose(StorageId.id.id)}>
            <h3 className="pl-[90%] pt-[10px] text-lg font-medium text-[#1C1243]">
              <svg
                width="11"
                height="10"
                viewBox="0 0 11 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.04289 0.292893C1.43342 -0.0976311 2.06658 -0.0976311 2.45711 0.292893L5.75 3.58579L9.04289 0.292893C9.43342 -0.0976309 10.0666 -0.0976309 10.4571 0.292893C10.8476 0.683418 10.8476 1.31658 10.4571 1.70711L7.16421 5L10.4571 8.29289C10.8476 8.68342 10.8476 9.31658 10.4571 9.70711C10.0666 10.0976 9.43342 10.0976 9.04289 9.70711L5.75 6.41421L2.45711 9.70711C2.06658 10.0976 1.43342 10.0976 1.04289 9.70711C0.652369 9.31658 0.652369 8.68342 1.04289 8.29289L4.33579 5L1.04289 1.70711C0.652369 1.31658 0.652369 0.683418 1.04289 0.292893Z"
                  fill="white"
                />
              </svg>
            </h3>
          </button>
        </div>
        <input
            type="file"
            name="files"
            className=''
            multiple
            accept="image/*"
            onChange={(e) => handleSelectFile(e)}
        />
        {selectedFiles.length > 0 && (
          <>
          <div className='flex flex-wrap justify-center gap-3 px-4 py-2 w-full'>
            {selectedFiles.map((url, index) => (
              <div key={index} className='relative'>
                <img className='w-20 h-20 object-cover rounded-lg' src={url} alt={`preview-${index}`} />
                <button
                  onClick={() => handleRemoveFile(index)}
                  className='absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center leading-none'
                >×</button>
              </div>
            ))}
          </div>
          <div className='flex mb-20 justify-center font-sans'>
            <button className='h-[48px] w-[178px] text-xl text-white font-semibold mt-2 px-4 bg-black badge border-0' onClick={() => handleDeleteImage()}>Cancelar</button>
            <button
              className="h-[48px] w-[178px] rounded-lg text-xl text-white font-semibold mt-2 ml-2 text-sm px-4 bg-blue-500 badge border-0"
              onClick={() => uploadFiles()}
            >
              {(loading) ? "Guardando..." : 'Guardar'}
            </button>
          </div>
          </>
        )}
    </div>
    </>
  )
}
